import { useLocalObservable } from 'mobx-react-lite';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

import { RouterLink } from 'APP/router/constants';
import { buildPath } from 'APP/router/helpers/buildPath';
import { UnauthorizedRouts } from 'APP/unauthorized/UnauthorizedView.constants';
import Entities from 'STORE';

import { ISetView, ViewType } from '../CallInvitation.types';

export interface INameBlockFormData {
  name: string;
}

interface INameBlockPresenter {
  onSubmit(data: INameBlockFormData): Promise<void>;
  goBack(): void;
}

type TForm = UseFormReturn<INameBlockFormData>;

interface IUseNameBlockPresenter {
  presenter: INameBlockPresenter;
  form: TForm;
}

export const useNameBlockPresenter = (setView: ISetView): IUseNameBlockPresenter => {
  const params = useParams<{ channelId?: string }>();
  const navigate = useNavigate();

  const form = useForm<INameBlockFormData>({
    defaultValues: {
      name: '',
    },
  });

  const presenter = useLocalObservable<INameBlockPresenter>(() => ({
    async onSubmit(data): Promise<void> {
      Entities.callInvitation.setSelfName(data.name);

      navigate(
        buildPath([RouterLink.Unauthorized, UnauthorizedRouts.CallPreview], {
          channelId: params.channelId,
        })
      );
    },
    goBack(): void {
      setView(ViewType.JoinView);
    },
  }));

  return { presenter, form };
};
